import { createContext } from 'react'

// Deliberately untyped: callers provide partial values (tests especially), and
// `useHsAppContext` is where the shape is asserted.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const HsAppContext = createContext<any>(undefined)
